var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "79C3A036-6B65-45D7-8BB5-E1C88CC513AF@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navic-GoSend-FINAL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.5a-Details",
    transform: "translate(-147.000000, -108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Expand-less",
    transform: "translate(147.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71079668,15.7036703 C6.32232096,16.0962324 5.68916464,16.0995452 5.29660248,15.7110694 C4.90404031,15.3225937 4.90072759,14.6894374 5.28920332,14.2968752 L11.1808756,8.34323521 C11.630736,7.88561859 12.369264,7.88561859 12.8167967,8.34087522 L18.7107967,14.2968752 C19.0992724,14.6894374 19.0959597,15.3225937 18.7033975,15.7110694 C18.3108354,16.0995452 17.677679,16.0962324 17.2892033,15.7036703 L11.9999999,10.3588254 L6.71079668,15.7036703 Z",
    id: "navigation/24/ic_expand_less",
    fill: "#00AA13",
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLess);
export default __webpack_public_path__ + "static/media/expand-less.4c4367d56e7aba965dd9dfd572e06ba2.svg";
export { ForwardRef as ReactComponent };